import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * "Show / hide the nav preview" toggle of the beamer nav — one cell of the layout's grid (`display: contents`).
 * Pure UI: the layout handles `toggled`.
 * Styles: libs/styles/slide-sync/beamer-navigation/_nav-parts.scss (global, beamer themes).
 */
@Component({
    selector: 'pcp-nav-basic-toggle',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconButton, MatIcon, MatTooltip, TranslocoPipe],
    template: `
        <div class="grid-cell">
            @if (!shown()) {
                <button
                    mat-icon-button
                    (click)="toggled.emit(true)"
                    matTooltip="Vorschauelemente anzeigen"
                    class="show-preview-button"
                    [title]="'icon-button.show-preview' | transloco"
                >
                    <mat-icon>visibility</mat-icon>
                </button>
            } @else {
                <button
                    mat-icon-button
                    (click)="toggled.emit(false)"
                    matTooltip="Vorschauelemente verstecken"
                    class="show-preview-button"
                    [title]="'icon-button.hide-preview' | transloco"
                >
                    <mat-icon>close</mat-icon>
                </button>
            }
        </div>
    `,
})
export class NavBasicToggleComponent {
    /** The basic slides preview is open. */
    readonly shown = input(false);
    /** true = show the preview, false = hide it. */
    readonly toggled = output<boolean>();
}
